import type { TreeCollaboratorDto } from "api/types";
import React from "react";

import styles from "./CollaboratorStack.module.css";

const MAX_VISIBLE = 5;

const getInitials = (name: string): string =>
	name
		.split(/\s+/)
		.filter(Boolean)
		.slice(0, 2)
		.map((word: string) => word[0]?.toUpperCase() ?? "")
		.join("") || "U";

export type CollaboratorStackProps = {
	collaborators: TreeCollaboratorDto[];
	/** Accessible name and text label, e.g. "3 collaborators". */
	label: string;
	onClick: () => void;
	/** Hides the text label, leaving avatars only (used by compact headers). */
	showLabel?: boolean;
};

/** Overlapping collaborator avatars; clicking opens the collaborators dialog. */
export const CollaboratorStack = ({ collaborators, label, onClick, showLabel = true }: CollaboratorStackProps) => (
	<button aria-label={label} className={styles.stackButton} onClick={onClick} title={label} type="button">
		<span className={styles.stack}>
			{collaborators.slice(0, MAX_VISIBLE).map((collaborator: TreeCollaboratorDto) => (
				<span key={collaborator.userId} className={styles.avatar}>
					{collaborator.profileImageUrl ? (
						<img alt="" referrerPolicy="no-referrer" src={collaborator.profileImageUrl} />
					) : (
						getInitials(collaborator.fullName)
					)}
				</span>
			))}
			{collaborators.length > MAX_VISIBLE && (
				<span className={styles.avatar}>+{collaborators.length - MAX_VISIBLE}</span>
			)}
		</span>
		{showLabel && <span className={styles.label}>{label}</span>}
	</button>
);
